import Spinner from 'react-bootstrap/Spinner';

function Loader({show}:any) {
  return (
    show &&
    <div className='spinnerDiv'>

    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
    </div>
  );
}

export default Loader;